import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { cloneElement } from 'react';
import classnames from 'classnames';
import { PureComponent } from '../component';
import { getKey as _getKey, getUidStr } from '../utils/uid';
import { menuClass } from './styles';
import List from './List';
import { consumer } from './context';
import { isLink } from '../utils/is';
import { isRTL } from '../config';
import { getParent, wrapSpan } from '../utils/dom/element';
import { DefaultProps } from './Root';

var getBaseIndent = function getBaseIndent() {
  return 16;
};

var calcIndent = function calcIndent(flag, indent) {
  if (!flag) return indent;
  return Math.ceil(indent / 3 * 2);
};

var Item =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Item, _PureComponent);

  var _super = _createSuper2(Item);

  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    _this = _super.call(this, props);
    _this.id = void 0;
    _this.handleMouseEnter = void 0;
    _this.handleMouseLeave = void 0;
    _this.element = void 0;
    _this.toggleTimer = void 0;
    _this.id = "".concat(props.path, ",").concat(getUidStr());

    var key = _this.getKey(props);

    var noop = function noop() {};

    var _props$bindItem = props.bindItem(_this.id, noop, noop, noop),
        _props$bindItem2 = _slicedToArray(_props$bindItem, 3),
        activeUpdate = _props$bindItem2[0],
        openUpdate = _props$bindItem2[1],
        inPathUpdate = _props$bindItem2[2];

    _this.state = {
      open: openUpdate(key),
      isActive: activeUpdate(_this.id, props.data),
      inPath: inPathUpdate(_this.id),
      isHighLight: false
    };
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleSwitch = _this.handleSwitch.bind(_assertThisInitialized(_this));
    _this.handleMouseEnter = _this.handleToggle.bind(_assertThisInitialized(_this), true);
    _this.handleMouseLeave = _this.handleToggle.bind(_assertThisInitialized(_this), false);
    _this.renderLink = _this.renderLink.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Item, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Item.prototype), "componentDidMount", this).call(this);

      this.props.bindItem(this.id, this.update.bind(this), this.updateOpen.bind(this), this.updateInPath.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(Item.prototype), "componentWillUnmount", this).call(this);

      this.props.unbindItem(this.id);
      this.unbindDocumentEvent();
    }
  }, {
    key: "getKey",
    value: function getKey() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      return _getKey(props.data, props.keygen, props.index);
    }
  }, {
    key: "getCalcStyle",
    value: function getCalcStyle() {
      var style = {};
      var _this$props = this.props,
          frontCaret = _this$props.frontCaret,
          level = _this$props.level,
          _this$props$inlineInd = _this$props.inlineIndent,
          inlineIndent = _this$props$inlineInd === void 0 ? DefaultProps.inlineIndent : _this$props$inlineInd,
          mode = _this$props.mode;
      var rtl = isRTL();
      if (mode !== 'inline') return style;
      var indent = calcIndent(frontCaret, inlineIndent);

      if (rtl) {
        style.paddingRight = getBaseIndent() + level * indent;
      } else {
        style.paddingLeft = getBaseIndent() + level * indent;
      }

      return style;
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      this.element = el;
    }
  }, {
    key: "unbindDocumentEvent",
    value: function unbindDocumentEvent() {
      document.removeEventListener('click', this.handleMouseLeave);
    }
  }, {
    key: "update",
    value: function update(check, activePath) {
      var isActive = check(this.id, this.props.data);
      var isHighLight = activePath && isActive ? activePath.indexOf(this.id) > -1 : false;
      this.setState({
        isActive: isActive,
        isHighLight: isHighLight
      });
    }
  }, {
    key: "updateOpen",
    value: function updateOpen(check) {
      var isOpen = check(this.getKey());
      this.setState({
        open: isOpen
      });
    }
  }, {
    key: "updateInPath",
    value: function updateInPath(check) {
      var inPath = check(this.id);
      this.setState({
        inPath: inPath
      });
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(open) {
      var _this$props2 = this.props,
          toggleOpenKeys = _this$props2.toggleOpenKeys,
          toggleDuration = _this$props2.toggleDuration;
      var key = this.getKey();
      if (this.toggleTimer) clearTimeout(this.toggleTimer);

      if (open) {
        toggleOpenKeys(key, true);
        document.addEventListener('click', this.handleMouseLeave);
      } else {
        this.toggleTimer = setTimeout(function () {
          toggleOpenKeys(key, false);
        }, toggleDuration);
        this.unbindDocumentEvent();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props3 = this.props,
          data = _this$props3.data,
          onClick = _this$props3.onClick,
          mode = _this$props3.mode,
          toggleOpenKeys = _this$props3.toggleOpenKeys,
          looseChildren = _this$props3.looseChildren,
          parentSelectable = _this$props3.parentSelectable;
      var expandClick = getParent(e.target, ".".concat(menuClass('expand')));
      var canExpand = !parentSelectable || expandClick;

      if (mode === 'inline' && data.children && canExpand) {
        var shouldToggle = looseChildren || data.children.length;
        if (shouldToggle) toggleOpenKeys(this.getKey(), !this.state.open);
        if (parentSelectable && expandClick) return;
      }

      if (data.disabled) return;

      if (typeof data.onClick === 'function') {
        data.onClick(this.id, data);
      } else if ((!data.children || data.children.length === 0 || data.onClick === true || parentSelectable) && typeof onClick === 'function') {
        onClick(this.id, data);
      }

      var isLeaf = ((data || {}).children || []).length === 0;
      if (!isLeaf) e.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: "handleItemClick",
    value: function handleItemClick(clickMethod, e) {
      clickMethod();
      this.handleClick(e);
    }
  }, {
    key: "handleSwitch",
    value: function handleSwitch(e) {
      var _this$props4 = this.props,
          renderItem = _this$props4.renderItem,
          data = _this$props4.data,
          index = _this$props4.index;
      var item = renderItem(data, index);

      if (item.props && item.props.onClick) {
        this.handleItemClick(item.props.onClick, e);
      } else {
        this.handleClick(e);
      }
    }
  }, {
    key: "renderLink",
    value: function renderLink(data) {
      var linkKey = this.props.linkKey;
      if (!linkKey) return null;
      if (typeof linkKey === 'function') return linkKey(data);
      return data[linkKey];
    }
  }, {
    key: "renderItem",
    value: function renderItem() {
      var hasChilds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var style = arguments.length > 1 ? arguments[1] : undefined;
      var _this$props5 = this.props,
          renderItem = _this$props5.renderItem,
          data = _this$props5.data,
          index = _this$props5.index,
          frontCaret = _this$props5.frontCaret,
          caretColor = _this$props5.caretColor;
      var item = renderItem(data, index);
      var link = this.renderLink(data);

      if (isLink(item)) {
        var mergeClass = classnames(menuClass('title'), item.props && item.props.className);
        var mergeStyle = Object.assign({}, style, item.props && item.props.style);
        return (
          /*#__PURE__*/
          cloneElement(item, {
            className: mergeClass,
            style: mergeStyle,
            onClick: this.handleSwitch
          })
        );
      }

      var props = {
        className: menuClass('title'),
        style: style,
        onClick: this.handleClick
      };
      if (link) props.href = link;

      if (frontCaret) {
        return (
          /*#__PURE__*/
          React.createElement("a", props,
          /*#__PURE__*/
          React.createElement("div", {
            style: {
              color: caretColor
            },
            className: menuClass('caret', hasChilds && 'has-childs')
          }), wrapSpan(item))
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("a", props, wrapSpan(item),
        /*#__PURE__*/
        React.createElement("span", {
          className: menuClass('expand'),
          style: {
            color: caretColor
          }
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          data = _this$props6.data,
          renderItem = _this$props6.renderItem,
          mode = _this$props6.mode,
          keygen = _this$props6.keygen,
          level = _this$props6.level,
          onClick = _this$props6.onClick,
          inlineIndent = _this$props6.inlineIndent,
          disabled = _this$props6.disabled,
          toggleOpenKeys = _this$props6.toggleOpenKeys,
          bottomLine = _this$props6.bottomLine,
          topLine = _this$props6.topLine,
          linkKey = _this$props6.linkKey,
          toggleDuration = _this$props6.toggleDuration,
          frontCaret = _this$props6.frontCaret,
          looseChildren = _this$props6.looseChildren,
          parentSelectable = _this$props6.parentSelectable,
          frontCaretType = _this$props6.frontCaretType;
      var _this$state = this.state,
          open = _this$state.open,
          isActive = _this$state.isActive,
          isHighLight = _this$state.isHighLight,
          inPath = _this$state.inPath;
      var dChildren = data.children;
      var children = dChildren || [];
      var isDisabled = typeof disabled === 'function' ? disabled(data) : disabled;
      var isUp = false;

      if (mode === 'vertical-auto' && this.element) {
        isUp = this.element.getBoundingClientRect().bottom - topLine > (bottomLine - topLine) / 2;
      }

      var hasChilds = looseChildren ? Array.isArray(dChildren) : children.length > 0;
      var className = menuClass('item', isDisabled === true && 'disabled', hasChilds ? 'has-children' : 'no-children', isActive && 'active', open && 'open', isUp && 'open-up', isHighLight && 'highlight', inPath && 'in-path', frontCaret && "caret-".concat(frontCaretType), parentSelectable && 'selectable');
      var style = this.getCalcStyle();
      var events = {};

      if (mode !== 'inline') {
        events.onMouseEnter = this.handleMouseEnter;
        events.onMouseLeave = this.handleMouseLeave;
      }

      return (
        /*#__PURE__*/
        React.createElement("li", Object.assign({
          className: className
        }, events, {
          ref: this.bindElement
        }), this.renderItem(hasChilds, style), hasChilds &&
        /*#__PURE__*/
        React.createElement(List // className={menuClass('sub')}
        , {
          data: children,
          disabled: disabled,
          renderItem: renderItem,
          keygen: keygen,
          inlineIndent: mode === 'horizontal' ? 0 : inlineIndent,
          mode: mode === 'horizontal' ? 'inline' : mode,
          onClick: onClick,
          path: this.id,
          level: level + 1,
          open: open,
          toggleOpenKeys: toggleOpenKeys,
          linkKey: linkKey,
          toggleDuration: toggleDuration,
          frontCaret: frontCaret,
          looseChildren: looseChildren,
          parentSelectable: parentSelectable
        }))
      );
    }
  }]);

  return Item;
}(PureComponent);

export default consumer(Item);